import { Link } from 'react-router-dom'
import type { BillingStatusResponse } from '@spoofio/shared/types'

type TrialBannerProps = {
  billingStatus: BillingStatusResponse
}

function getDaysRemaining(trialEndsAt: string | undefined): number {
  if (!trialEndsAt) return 0
  const now = new Date()
  const end = new Date(trialEndsAt)
  const diffMs = end.getTime() - now.getTime()
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)))
}

export function TrialBanner({ billingStatus }: TrialBannerProps) {
  const { organization } = billingStatus
  if (organization.status !== 'trial') return null

  const daysRemaining = getDaysRemaining(organization.trialEndsAt)

  return (
    <div className="rounded-lg bg-primary-50 border border-primary-200 p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <svg className="h-5 w-5 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm font-medium text-primary-800">
            {daysRemaining > 0
              ? `${daysRemaining} day${daysRemaining === 1 ? '' : 's'} remaining in your free trial.`
              : 'Your free trial has expired.'}
            {' '}Subscribe now to keep your canaries active.
          </p>
        </div>
        <Link
          to="/billing"
          className="btn btn-primary text-sm whitespace-nowrap"
        >
          Subscribe Now
        </Link>
      </div>
    </div>
  )
}
